/* src/app/layout/layout/layout.component.scss */
/*# sourceMappingURL=layout.component-YZGMTWYG.css.map */
